import React from "react";
import { Table, Spinner } from "react-bootstrap";
import type { TableResults } from "./FootageRestrictedLocateMaintenance";

interface FootageRestrictedLocateTableProps {
  loadingStatus: boolean;
  filteredData: TableResults[];
  selectedTableData: TableResults;
  handleRowClick: (id: number) => void;
}

interface TableRowProps {
  item: TableResults;
  isSelected: boolean;
  onClick: () => void;
}

const LoadingSpinner = () => (
  <div className="footage-res-locate-table-loader">
    <Spinner animation="border" role="status"></Spinner>
  </div>
);

const TableRow = ({
  item,
  isSelected,
  onClick,
}: TableRowProps) => {
  const className = isSelected
    ? "footage-restricted-locate-mant-row-selected"
    : "";

  return (
    <tr onClick={onClick} className={className}>
      <td>{item.FootageRestrictedLocateConfig.ContractId}</td>
      <td>{item.UtilityName}</td>
      <td>{item.FootageRestrictedLocateConfig.HourlyMinimum}</td>
      <td>{item.FootageRestrictedLocateConfig.MinBillableMinutes}</td>
      <td>{item.FootageRestrictedLocateConfig.MaxLocates}</td>
      <td>{item.FootageRestrictedLocateConfig.MaxFootage}</td>
      <td>{item.FootageRestrictedLocateConfig.FootagePerLocate}</td>
      <td
        style={{
          color: item.FootageRestrictedLocateConfig.IsActive
            ? "inherit"
            : "red",
        }}
      >
        {item.FootageRestrictedLocateConfig.IsActive ? "Active" : "Inactive"}
      </td>
    </tr>
  );
};

const FootageRestrictedLocateTable: React.FC<
  FootageRestrictedLocateTableProps
> = ({ loadingStatus, filteredData, selectedTableData, handleRowClick }) => {
  if (loadingStatus) {
    return <LoadingSpinner />;
  }

  return (
    <div className="fixed-table-frlm">
      <Table striped bordered hover responsive size="md">
        <thead>
          <tr>
            <th>Contract ID</th>
            <th
              style={{
                width: "400px",
              }}
            >
              Utility
            </th>
            <th>Hourly Minimum</th>
            <th>Min Billable Minutes</th>
            <th>Max Locates</th>
            <th>Max Footage</th>
            <th>Footage Per Locate</th>
            <th
              style={{
                width: "80px",
              }}
            >
              Status
            </th>
          </tr>
        </thead>
        <tbody>
          {filteredData?.map((item, index) => (
            <TableRow
              key={item.FootageRestrictedLocateConfig.Id}
              item={item}
              isSelected={
                selectedTableData.FootageRestrictedLocateConfig.Id ===
                item.FootageRestrictedLocateConfig.Id
              }
              onClick={() =>
                handleRowClick(item.FootageRestrictedLocateConfig.Id)
              }
            />
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default FootageRestrictedLocateTable;
